class ClassificacaoLoteEnum {
  constructor() {
    this.EXCLUSIVO = 1;
    this.COTA = 2;
    this.LIVRE_CONCORRENCIA = 3;
  }

  getTiposLabel() {
    return [
      { label: 'Exclusivo', value: this.EXCLUSIVO },
      { label: 'Cota', value: this.COTA },
      { label: 'Livre concorrência', value: this.LIVRE_CONCORRENCIA },
    ];
  }

  getTipo(classificacao) {
    return this.getTiposLabel()
      .filter(label => label.value === classificacao)
      .shift();
  }
}

export default new ClassificacaoLoteEnum();
